import { action, computed, observable, makeObservable } from 'mobx';
import React from 'react';
import {toInt} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {SelectItem, SelectQuestionModel} from '../models';
import {
  checkAllItems,
  selectItemsById,
  SelectOption,
  selectOptionsById,
  SelectQuestionState,
  SelectState,
  SelectStates,
  setSelected
} from './models';

export class SelectQuestionStore {
  readonly selectItemsById: ReadonlyMap<string, SelectItem>;
  readonly selectOptionsById: ReadonlyMap<string, readonly SelectOption[]>;

  constructor(readonly id: number,
              readonly model: SelectQuestionModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
    this.selectItemsById = selectItemsById(this.model);
    this.selectOptionsById = selectOptionsById(this.selectItemsById);
  }

  @computed
  get selectQuestionState(): SelectQuestionState {
    const states: {[index: string]: SelectState} = {} as SelectStates;
    const altSelectQuestionState: SelectQuestionState = { states };

    this.selectItemsById.forEach((value, key) => {
      Object.assign(altSelectQuestionState.states, {[key]: {checkCount: 0, selected: null, checked: false}})
    })

    return this.stateStore.getContentState<SelectQuestionState>(this.id) ? this.stateStore.getContentState<SelectQuestionState>(this.id)! : altSelectQuestionState;
  }

  @action
  check = () => {
    if (this.selectQuestionState === null)
      return;
    this.updateState(checkAllItems(this.selectQuestionState));
  };

  @action
  changeHandler(selectId: string, event: React.ChangeEvent<HTMLSelectElement>) {
    const value = event.target.value;
    const intValue = toInt(value);
    this.select(selectId, intValue);
  }

  @action
  private select(selectId: string, selected: number | null) {
    this.updateState(setSelected(this.selectQuestionState, selectId, selected));
  }

  @action
  private updateState(state: SelectQuestionState) {
    this.stateStore.setContentState<SelectQuestionState>(this.id, state);
  }
}
